import { definePart } from '../core/effect';
import { MIN_FONT } from '../core/hud';
import { rgba } from '../canvas/paint';

/**
 * **文字**（Issue #530）。「SET」「BATTLE PHASE」のような演出の見出し。
 *
 * **中身は `props.text`** で演出が渡す（素材は「文字を描く」ことだけを知っている）。
 * 大きさは `core/hud::MIN_FONT`（46px）を下限にする —— スマホで動画を見る人に読めない字を出さない
 * （Issue #493 と同じ理由）。**縁取りは `paint-order` が無い canvas では先に描く**。
 */
export default definePart({
  id: 'text',
  label: '文字',
  /** 素の大きさ（Issue #531。舞台のピクセル基準。`beam` と同じ理由） */
  size: { w: 1400, h: 240 },
  schema: {
    text: { type: 'text', label: '文字' },
    size: { type: 'number', label: '大きさ', min: MIN_FONT, max: 320, step: 1 },
    color: { type: 'color', label: '色' },
    strokeColor: { type: 'color', label: '縁の色' },
    strokeW: { type: 'number', label: '縁の太さ', min: 0, max: 24, step: 1 },
    weight: { type: 'number', label: '太さ', min: 100, max: 900, step: 100 },
    letterSpacing: { type: 'number', label: '字間', min: -10, max: 40, step: 1 },
  },
  style: { text: '', size: 120, color: '#ffffff', strokeColor: '#101018', strokeW: 8, weight: 800, letterSpacing: 6 },

  draw(ctx, { size, style }) {
    const text = String(style.text ?? '');
    if (!text || !(size.w > 0) || !(size.h > 0)) return;
    const px = Math.max(MIN_FONT, style.size);
    ctx.font = `${style.weight} ${px}px sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    if (ctx.letterSpacing !== undefined) ctx.letterSpacing = `${style.letterSpacing}px`;
    const x = size.w / 2;
    const y = size.h / 2;
    if (style.strokeW > 0) {
      ctx.lineJoin = 'round';
      ctx.lineWidth = style.strokeW * 2;   // 半分が内側に食うので倍に引く
      ctx.strokeStyle = rgba(style.strokeColor, 1);
      ctx.strokeText(text, x, y);
    }
    ctx.fillStyle = rgba(style.color, 1);
    ctx.fillText(text, x, y);
  },
});
